import { DateRangeAndModeSettings } from '@common-modules/common-filters/components/derivated/date-range-and-mode/date-range-and-mode.settings';

export class SATimeFrameSelectorSettings {
  dateRangeAndModeSettings: DateRangeAndModeSettings;

  constructor(init?: SATimeFrameSelectorSettings) {
    Object.assign(this, init);
  }
}
